import * as ActionType from "../actionTypes/chartDermatologyActionTypes";

export function toggleArea(index) {
  return {
    type: ActionType.CHART_DERMATOLOGY_TOGGLE_AREA,
    index,
  };
}
